module.exports = __webpack_public_path__ + "static/media/leaf-maple.bb23ac90.svg";